module.exports = {
  sanity: {
    projectId: 'p5w99mn3' || '<#< sanity.projectId >#>',
    dataset: 'production' || '<#< sanity.dataset >#>'
  }
}

// TODO: process.env files 